import {
  POST_IMPERSONATE,
  POST_IMPERSONATE_FAILED,
  POST_IMPERSONATE_SUCCESS,
} from "./actionTypes";

export const postImpersonate = (data) => {
  return {
    type: POST_IMPERSONATE,
    payload: data,
  };
};
export const postImpersonateSuccess = (data) => {
  return {
    type: POST_IMPERSONATE_SUCCESS,
    payload: data,
  };
};

export const postImpersonateFailed = (error) => {
  return {
    type: POST_IMPERSONATE_FAILED,
    payload: error,
  };
};
